import VDMDashboardChemicalROBS from "components/app/vdmdashboard/chemical-robs/VDMDashboardChemicalROBS";
import React from "react";

type ScreenVDMChemicalROBSType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMChemicalROBS: React.FC<ScreenVDMChemicalROBSType> = (
	props: ScreenVDMChemicalROBSType
) => {
	return <VDMDashboardChemicalROBS vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMChemicalROBS;